import {
  INVITE_AGENT_ERROR,
  INVITE_AGENT_START,
  INVITE_AGENT_SUCCESS,
} from 'constants/action-types/organizations/inviteAgent';

export default (state, { type, payload }) => {
  switch (type) {
    case INVITE_AGENT_START:
      return {
        ...state,
        inviteAgent: {
          ...state.inviteAgent,
          loading: true,
          error: null,
        },
      };
    case INVITE_AGENT_ERROR:
      return {
        ...state,
        inviteAgent: {
          ...state.inviteAgent,
          error: payload,
          loading: false,
        },
      };
    case INVITE_AGENT_SUCCESS:
      return {
        ...state,
        inviteAgent: {
          ...state.inviteAgent,
          data: payload.data,
          loading: false,
        },
      };
    default:
      return null;
  }
};
